import type { EntityReference } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getVenuesRefData(): Promise<EntityReference[]> {
  return requestApiJsonOrThrow<EntityReference[]>('admin/reference-data/venues')
}

export const venuesRefDataQuery = {
  queryKey: ['venues-ref-data'],
  queryFn: () => getVenuesRefData(),
}
